module.exports = __webpack_public_path__ + "static/media/antena rock@2x.9647d69d.png";